import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, fmtDateTime } from "@/lib/api";
import { useEntity } from "@/lib/entityStore";
import { ArrowUpRight } from "lucide-react";
import { Card } from "@/components/ds/Card";
import { PageShell, PageHeader, Section } from "@/components/ds/PageShell";
import { ProductionBadge } from "@/components/ds/ProductionBadge";

export default function Entities() {
    const { entities, refreshEntities } = useEntity();
    const nav = useNavigate();

    useEffect(() => {
        refreshEntities();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <PageShell width="default" testId="entities-page">
            <PageHeader
                eyebrow="Configuration"
                title="Entities"
                subtitle="The six MYOB company files that make up All Crane Sales. Each entity stays logically separated — data is only ever consolidated inside intentional group reporting."
            />

            <Section>
                <Card variant="default" padding="none" className="overflow-hidden">
                    <table className="w-full text-[14px]">
                        <thead>
                            <tr className="text-left border-b border-stone-100 bg-stone-50/40">
                                <th className="px-5 py-3 label-soft text-stone-500 font-medium">Entity</th>
                                <th className="px-3 py-3 label-soft text-stone-500 font-medium">Legal name</th>
                                <th className="px-3 py-3 label-soft text-stone-500 font-medium">Mode</th>
                                <th className="px-3 py-3 label-soft text-stone-500 font-medium">Connection</th>
                                <th className="px-3 py-3 label-soft text-stone-500 font-medium">Sync</th>
                                <th className="px-3 py-3 label-soft text-stone-500 font-medium">Last sync</th>
                                <th className="px-5 py-3" />
                            </tr>
                        </thead>
                        <tbody>
                            {entities.map((e) => (
                                <tr
                                    key={e.id}
                                    className="border-b border-stone-100 last:border-0 hover:bg-stone-50/50 cursor-pointer transition group"
                                    onClick={() => nav(`/entities/${e.id}`)}
                                    data-testid={`entities-row-${e.entity_number}`}
                                >
                                    <td className="px-5 py-3.5 font-medium text-stone-800">
                                        {e.display_name}
                                    </td>
                                    <td className="px-3 py-3.5 text-stone-600">{e.legal_name}</td>
                                    <td className="px-3 py-3.5">
                                        <ProductionBadge state={e.data_mode || "mock"} />
                                    </td>
                                    <td className="px-3 py-3.5 capitalize text-stone-700">
                                        {e.connection_status.replace("_", " ")}
                                    </td>
                                    <td className="px-3 py-3.5 capitalize text-stone-700">{e.sync_health}</td>
                                    <td className="px-3 py-3.5 font-mono-num text-[12px] text-stone-500">
                                        {fmtDateTime(e.last_sync_at)}
                                    </td>
                                    <td className="px-5 py-3.5 text-right">
                                        <ArrowUpRight
                                            size={14}
                                            strokeWidth={2}
                                            className="text-stone-300 group-hover:text-stone-700 transition inline"
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Card>
            </Section>
        </PageShell>
    );
}
